const CUSTOM_APP_URL = 'https://loccitane-si.dev.bambooapp.eu'

if (window) {
  window.loccitane = window.loccitane || {};

  if (window.loccitane.newsletter === undefined) {
    window.loccitane.newsletter = {
      subscribeUrl: `${CUSTOM_APP_URL}/api/customers/subscribe`,
    };
  }

  if (window.loccitane.customer === undefined) {
    window.loccitane.customer = {
      registerUrl: `${CUSTOM_APP_URL}/api/customers/register`,
      updateUrl: `${CUSTOM_APP_URL}/api/customers/update`,
      crmDataUrl: `${CUSTOM_APP_URL}/api/customers/crm-data`,
    };
  }

  if (window.loccitane.toast === undefined) {
    window.loccitane.toast = {
      success: (message) => {
        Toastify({
          text: message,
          duration: 3000,
          close: false,
          gravity: 'bottom',
          position: 'right',
          style: {
            background: 'var(--yellow)',
            color: '#001022',
            fontWeight: 'bold',
            cursor: 'default',
          },
        }).showToast();
      }
    };
  }
}

class NewsletterForm extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      details: this.querySelector('[id^="NewsletterForm-Details"]'),
      summary: this.querySelector('[id^="NewsletterForm-Summary"]'),
      form: this.querySelector('[id^="NewsletterForm-Form"]'),
      submitButton: this.querySelector('[id^="NewsletterForm-Button-Submit"]'),
      emailInput: this.querySelector('[id^="NewsletterForm-Input-Email"]'),
      emailInputError: this.querySelector('[id^="NewsletterForm-Error-Email"]'),
    }

    this.templates = {
      success: this.querySelector('[id^="NewsletterForm-Template-Success"]'),
    }

    if (this.elements.details) {
      this.elements.details.addEventListener('toggle', this.onToggle.bind(this));
    }

    if (this.elements.form) {
      this.elements.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    if (this.elements.emailInput) {
      this.elements.emailInput.addEventListener('input', this.onInput.bind(this));
    }
  }

  renderSuccess() {
    if (this.templates.success) {
      const wrapper = this.querySelector('.newsletter__wrapper');

      if (wrapper) {
        wrapper.innerHTML = this.templates.success.innerHTML;
      } else {
        this.innerHTML = this.templates.success.innerHTML;
      }
    }

    window.loccitane.toast.success('Hvala! Poslali smo vam e-pošto o uspešni prijavi na e-novice.');
  }

  onInput(event) {
    if (this.elements.emailInput) {
      this.elements.emailInput.ariaInvalid = false;
      this.elements.emailInput.attributes['aria-describedby'] = '';
    }

    if (this.elements.emailInputError) {
      this.elements.emailInputError.textContent = '';
      this.elements.emailInputError.classList.add('hidden');
    }
  }

  onToggle(event) {
    if (this.elements.summary) {
      this.elements.summary.setAttribute('aria-expanded', event.target.open);

      if (event.target.open) {
        this.elements.summary.textContent = this.elements.summary.dataset.textClose;
      } else {
        this.elements.summary.textContent = this.elements.summary.dataset.textOpen;
      }
    }
  }

  onSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.elements.submitButton) {
      this.elements.submitButton.setAttribute('aria-disabled', true);
      this.elements.submitButton.classList.add('loading');
      this.querySelector('.loading__spinner').classList.remove('hidden');
    }

    const form = event.target;
    const formData = new FormData(form);
    const requestBody = {
      subscriber: {
        email: formData.get('subscriber[email]')
      }
    }

    fetch(
      window.loccitane.newsletter.subscribeUrl,
      {
        method: "POST",
        body: JSON.stringify(requestBody),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }).then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      }).then(data => {
        console.log(data);
        if (data.errors) {
          if (data.errors.subscriber.email) {

            const emailErrorMessage = data.errors.subscriber.email;
            if (emailErrorMessage.includes('ste že naročeni')) {
              this.elements.emailInputError.textContent = "S tem e-naslovom ste že prijavljeni na e-novice.";
            } else {
              this.elements.emailInputError.textContent = emailErrorMessage;
            }

            this.elements.emailInput.autofocus = true;
            this.elements.emailInput.ariaInvalid = true;
            this.elements.emailInput.attributes['aria-describedby'] = this.elements.emailInputError.id;
            this.elements.emailInputError.classList.remove('hidden');
          }
        } else {
          this.renderSuccess();
        }
      }).catch(error => {
        console.error('There has been a problem with your fetch operation:', error);
      }).finally(() => {
        if (this.elements.submitButton) {
          this.elements.submitButton.removeAttribute('aria-disabled');
          this.elements.submitButton.classList.remove('loading');
          this.querySelector('.loading__spinner').classList.add('hidden');
        }
      });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  customElements.define('newsletter-form', NewsletterForm);
});

// class AccordionItem extends HTMLElement {
//   constructor() {
//     super();

//     this.details = this.querySelector('details');
//     this.summary = this.querySelector('summary');

//     if (this.details) {
//       this.details.addEventListener('toggle', this.onToggle.bind(this));
//     }
//   }

//   onToggle(event) {
//     if (this.summary) {
//       this.summary.setAttribute('aria-expanded', event.target.open);

//       if (event.target.open) {
//         if (this.summary.dataset.textClose) {
//           this.summary.textContent = this.summary.dataset.textClose;
//         }
//       } else {
//         if (this.summary.dataset.textOpen) {
//           this.summary.textContent = this.summary.dataset.textOpen;
//         }
//       }
//     }
//   }
// }

// customElements.define('accordion-item', AccordionItem);


class PhoneInput extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      hiddenInput: this.querySelector('input[type="hidden"]'),
      input: this.querySelector('input[type="tel"]'),
    }

    if (this.elements.input) {
      this.elements.input.addEventListener('input', this.onInput.bind(this));
    }
  }

  onInput(event) {
    const value = event.target.value;

    if (!value.startsWith('+386')) {
      event.target.value = '+386';
    }

    const countryCode = '+386';
    const phoneNumber = value.slice(countryCode.length);

    const cleanedPhoneNumber = phoneNumber.replace(/\D/g, '');

    if (cleanedPhoneNumber !== "") {
      this.elements.input.value = `${countryCode}${cleanedPhoneNumber}`;
      this.elements.hiddenInput.value = `${countryCode}${cleanedPhoneNumber}`;
    } else {
      this.elements.input.value = countryCode;
      this.elements.hiddenInput.value = '';
    }
  }
}

customElements.define('phone-input', PhoneInput);

if (new URLSearchParams(window.location.search).get('registered')) {
  document.getElementById('notice').innerHTML = `
  <div class="note form-notice">
  <p>Poslali smo vam e-pošto za potrditev vašega računa.</p>
  </div>
  `;
}

